module.exports = __webpack_public_path__ + "Logo-fa7ff5aca8c4f40b17c997cdcf20afbc.png";